import { TriggeredAction } from '@/api/model/triggered-action'
import { RootState } from '@/store'
import { Module } from 'vuex'
import { actions } from '@/store/triggeredActions/actions'
import { mutations } from '@/store/triggeredActions/mutations'
import { getters } from '@/store/triggeredActions/getters'

export interface TriggeredActionState {
    loading: boolean,
    error: string|null,
    triggeredActions: TriggeredAction[],
    totalItems: number,
    totalPages: number,
    page: number,
    itemsPerPage: number,
    orderField: string|null,
    orderDirection: string|null,
    activeFilter: number[],
    companyFilter: string|null,
    nameFilter: string|null,
}

const state: TriggeredActionState = {
    loading: false,
    error: null,
    triggeredActions: [],
    totalItems: 0,
    totalPages: 0,
    page: 1,
    itemsPerPage: 10,
    orderField: null,
    orderDirection: null,
    activeFilter: null,
    companyFilter: null,
    nameFilter: null,
}

export const TriggeredActionModule: Module<TriggeredActionState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
